export const BRANDING_CATEGORY_TYPE = {
  LOAN_MARKET: 1,
  OWN_BRAND: 2,
  WEALTH_MARKET: 3,
  INSURANCE_MARKET: 4,
};
